import { UIHeading3, UIText2, Image, Label } from '@cian/ui-kit';
import { FC } from 'react';
import { Transport } from 'shared/components/Transport';
import { TransportTypes } from 'shared/types/TransportTypes';
import { RemotenessTypes } from 'shared/types/RemotenessTypes';
import { extractUndefined } from 'shared/utils/extractUndefined';
import styles from './ResidentialComplexesCardDefault.css';
import { RoomsInfoItem, RoomsList } from 'shared/components/RoomsList';

type TransportType = {
  id: number;
  name: string;
  iconColor?: string | null;
  remoteness?: string | null;
  remotenessType?: RemotenessTypes | null;
  iconType?: TransportTypes | null;
};

type ResidentialComplexesCardDefaultProps = {
  title: string;
  subtitle: string | null;
  transports: TransportType[];
  imageUrl: string;
  roomsInfo: RoomsInfoItem[];
  promoLabel: string | null;
  url: string;
};

export const ResidentialComplexesCardDefault: FC<ResidentialComplexesCardDefaultProps> = ({
  title,
  subtitle,
  transports,
  imageUrl,
  roomsInfo,
  promoLabel,
  url,
}) => {
  return (
    <a className={styles['container']} href={url} target="_blank" rel="noopener noreferrer">
      <div className={styles['image-wrapper']}>
        {!!promoLabel && (
          <div className={styles['promo-label-wrapper']}>
            <Label color="#fc4c02" background="control-inverted-primary-default">
              {promoLabel}
            </Label>
          </div>
        )}
        <div className={styles['image-wrapper-inner']}>
          <Image objectFit="cover" src={imageUrl} alt={title} width="100%" height={200} />
        </div>
      </div>
      <div className={styles['content']}>
        <div className={styles['title-wrapper']}>
          <UIHeading3 color="current_color">{title}</UIHeading3>
        </div>
        {!!subtitle && <UIText2 color="text-secondary-default">{subtitle}</UIText2>}

        {!!transports.length && (
          <div className={styles['transports-wrapper']} data-testid="transports-wrapper">
            {transports.map(transport => (
              <Transport
                key={transport.id}
                remotenessIconColor="icon-secondary-default"
                textColor="text-secondary-default"
                name={transport.name}
                iconColor={extractUndefined(transport.iconColor)}
                remoteness={extractUndefined(transport.remoteness)}
                remotenessType={extractUndefined(transport.remotenessType)}
                iconType={extractUndefined(transport.iconType)}
              />
            ))}
          </div>
        )}

        {!!roomsInfo.length && (
          <div className={styles['rooms-info-wrapper']}>
            <RoomsList list={roomsInfo} />
          </div>
        )}
      </div>
    </a>
  );
};
